import { ElementType, PropsWithChildren } from "react";
import { cardContentClasses } from "./CardContent.style";

export type CardContentProps = {
  className?: string;
  component?: ElementType;
};

const CardContent = (props: PropsWithChildren<CardContentProps>) => {
  const { className, component: Component = "div", ...rest } = props;
  return (
    <Component className={cardContentClasses({ class: className })} {...rest} />
  );
};

export default CardContent;
